import { useState } from "react";
import { useAuth } from "@/auth";
import { auth as authApi } from "@/api";
import { KeyRound, ShieldCheck } from "lucide-react";

function formatDetail(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").join(" ");
  return "Ocurrió un error, intenta de nuevo.";
}

export const ForcePasswordChange = () => {
  const { refresh } = useAuth();
  const [current, setCurrent] = useState("");
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (pwd !== pwd2) { setErr("Las contraseñas no coinciden."); return; }
    setBusy(true);
    try {
      await authApi.changePassword(current, pwd);
      await refresh();
    } catch (ex) {
      setErr(formatDetail(ex.response?.data?.detail) || "No se pudo cambiar la contraseña.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--cream)] px-4" data-testid="force-password-change">
      <div className="sketch-border bg-white p-8 max-w-md w-full">
        <img src="/brand/lala_elite_badge_md.png" alt="Lala Elite"
          className="h-20 w-20 object-contain mb-4" draggable={false} />
        <div className="flex items-center gap-3 mb-2 text-[var(--lala-blue)]">
          <ShieldCheck size={22} />
          <h1 className="text-xl font-bold">Crea tu contraseña personal</h1>
        </div>
        <p className="text-sm text-[var(--ink-soft)] mb-6">
          Por seguridad, debes reemplazar tu contraseña temporal antes de usar LALA Élite.
          Mínimo 10 caracteres, con mayúscula, minúscula y número.
        </p>
        <form onSubmit={submit} className="space-y-4">
          <input type="password" required value={current} onChange={(e) => setCurrent(e.target.value)}
            placeholder="Contraseña temporal actual"
            className="w-full border border-[var(--line)] rounded-lg px-3 py-2 text-sm"
            data-testid="fpc-current" />
          <input type="password" required value={pwd} onChange={(e) => setPwd(e.target.value)}
            placeholder="Nueva contraseña"
            className="w-full border border-[var(--line)] rounded-lg px-3 py-2 text-sm"
            data-testid="fpc-new" />
          <input type="password" required value={pwd2} onChange={(e) => setPwd2(e.target.value)}
            placeholder="Confirmar nueva contraseña"
            className="w-full border border-[var(--line)] rounded-lg px-3 py-2 text-sm"
            data-testid="fpc-confirm" />
          {err && <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg p-2" data-testid="fpc-error">{err}</div>}
          <button type="submit" disabled={busy}
            className="btn-primary w-full flex items-center justify-center gap-2 text-sm"
            data-testid="fpc-submit">
            <KeyRound size={16} /> {busy ? "Guardando…" : "Guardar contraseña"}
          </button>
        </form>
      </div>
    </div>
  );
};

export const PasswordChangeGate = ({ children }) => {
  const { user } = useAuth();
  if (user && user.must_change_password) return <ForcePasswordChange />;
  return children;
};
